// extracted by mini-css-extract-plugin
export default {"searchBar":"SearchBar_searchBar__vtjK3","searchIcon":"SearchBar_searchIcon__2HqdI","searchInput":"SearchBar_searchInput__MEjph"};